import React from "react"
import { useTranslation } from "react-i18next"

import { useEvent } from "shared/lib/useEvent"
import { Button } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface FollowUpConfigurationDeleteButtonProps {
  id: string
  onDelete: (id: string) => Promise<void>
  disabled?: boolean
}

export const FollowUpConfigurationDeleteButton = React.memo(
  ({ id, onDelete, disabled }: FollowUpConfigurationDeleteButtonProps) => {
    const { t } = useTranslation()

    const handleClick = useEvent(() => {
      onDelete(id)
    })

    return (
      <Button
        variant="tertiary"
        className="btn--borderless"
        onClick={handleClick}
        disabled={disabled}
        isIconOnly
        icon={IconName.BIN}
        isDanger
        label={t("General.Delete")}
      />
    )
  }
)

FollowUpConfigurationDeleteButton.displayName =
  "FollowUpConfigurationDeleteButton"
